import useAppDispatch from "stores/useAppDispatch";
const useDLPreviewDispatch = useAppDispatch;
export default useDLPreviewDispatch;
